import { create } from 'zustand';
import type { QueueTab, ReconciliationListFilters } from '../types';

interface FiltersState extends ReconciliationListFilters {
  setTab: (tab: QueueTab) => void;
  setFilter: <K extends keyof ReconciliationListFilters>(key: K, value: ReconciliationListFilters[K]) => void;
  reset: () => void;
}

export const useReconciliationFilters = create<FiltersState>((set) => ({
  tab: 'OPEN',
  kind: undefined,
  entityType: undefined,
  searchQuery: '',
  limit: 50,
  setTab: (tab) => set({ tab }),
  setFilter: (key, value) => set({ [key]: value || undefined }),
  reset: () =>
    set({
      kind: undefined,
      entityType: undefined,
      searchQuery: '',
      limit: 50,
    }),
}));
